// 漫画岛 - 分类数据
export interface Category {
  slug: string;
  name: string;
  icon: string;
  desc: string;
  count: number;
}

export const CATEGORIES: Category[] = [
  { slug: 'reXue', name: '热血', icon: 'ri-fire-line', desc: '燃点不断、勇往直前的热血篇章', count: 126 },
  { slug: 'lianAi', name: '恋爱', icon: 'ri-heart-line', desc: '甜蜜心动、青春悸动的恋爱故事', count: 158 },
  { slug: 'qiHuan', name: '奇幻', icon: 'ri-sparkling-line', desc: '异世界冒险与魔法构筑的幻想世界', count: 143 },
  { slug: 'keHuan', name: '科幻', icon: 'ri-rocket-line', desc: '星际冒险与未来科技的硬核想象', count: 97 },
  { slug: 'xuanYi', name: '悬疑', icon: 'ri-eye-line', desc: '烧脑推理与迷雾重重的高能谜案', count: 82 },
  { slug: 'riChang', name: '日常', icon: 'ri-sun-line', desc: '治愈人心、温暖真实的平淡日常', count: 168 },
  { slug: 'gaoXiao', name: '搞笑', icon: 'ri-emotion-laugh-line', desc: '笑点密集、轻松解压的欢乐日常', count: 114 },
  { slug: 'yunDong', name: '运动', icon: 'ri-play-line', desc: '热血赛场、追逐极限的运动青春', count: 69 },
];

// 漫画岛 - 漫画作品数据
export interface Comic {
  id: number;
  title: string;
  author: string;
  category: string;
  categorySlug: string;
  cover: string;
  short: string;
  intro: string[];
  tags: string[];
  rating: number;
  chapterCount: number;
  views: number;
  updated: string;
  featured: boolean;
  newArrival: boolean;
  status: string;
}

export const COMICS: Comic[] = [
  {
    id: 1,
    title: '炽焰少年',
    author: '林海星',
    category: '热血',
    categorySlug: 'reXue',
    cover: 'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20art%20of%20a%20determined%20young%20hero%20wreathed%20in%20blazing%20orange%20flames%2C%20dynamic%20heroic%20pose%2C%20bold%20dramatic%20lighting%2C%20vivid%20red%20and%20orange%20color%20palette%2C%20high%20contrast%2C%20clean%20vector%20style%2C%20striking%20composition%20for%20a%20shonen%20action%20comic%20cover&width=600&height=800&seq=cover-fire-boy&orientation=portrait',
    short: '背负家族之火的少年，为守护所爱之人踏上燃尽宿命的修行之路。',
    intro: ['十六岁的少年炎焰体内封印着上古火种，本是普通小镇少年的他，在一次妖兽袭击中觉醒了深埋血脉的力量。为守护亲人、查明父亲失踪的真相，他毅然踏上修行之路。', '一路上，炎焰结识了冷静睿智的剑士凌霜、来自东方的神秘占卜师以及一群志同道合的伙伴。他们在刀与火的交织中成长，在一次次生死考验里学会信任与担当。', '随着真相逐渐浮出水面，炎焰发现父亲失踪的背后，竟隐藏着一个足以颠覆整个大陆的巨大阴谋。当命运的火种再次燃起，他能否守护住珍视的一切？'],
    tags: ['热血', '战斗', '成长', '冒险'],
    rating: 9.4,
    chapterCount: 128,
    views: 2360000,
    updated: '2026-08-16',
    featured: true,
    newArrival: false,
    status: '连载中',
  },
  {
    id: 2,
    title: '星海旅人',
    author: '顾长空',
    category: '科幻',
    categorySlug: 'keHuan',
    cover: 'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20art%20of%20a%20lone%20space%20explorer%20standing%20before%20a%20glowing%20nebula%20and%20distant%20planets%2C%20deep%20cosmic%20blues%20and%20teal%20palette%2C%20cinematic%20sci-fi%20atmosphere%2C%20futuristic%20spaceship%20silhouettes%2C%20clean%20digital%20illustration%20for%20a%20science%20fiction%20comic%20cover&width=600&height=800&seq=cover-star-voyager&orientation=portrait',
    short: '一艘失落的星舰、一名来自地球的旅人，在广袤银河中追寻文明失落的真相。',
    intro: ['公元2247年，人类文明进入大星际时代。年轻的星际测绘员陆离在一次任务中意外穿越虫洞，抵达了一颗从未被记录过的遥远星球。', '在这里，他发现了早已灭亡的外星文明留下的遗迹，以及一段关于"星海"的古老预言。为了寻找回家的路，陆离与改造人伙伴一同驾驶残破的星舰"旅人号"，开始了跨越银河的漫长旅程。', '每一站停靠，都是一次关于文明、生命与选择的思考。而在旅程的尽头，等待他们的，是一个关于人类起源的惊人真相。'],
    tags: ['科幻', '星际', '冒险', '悬念'],
    rating: 9.1,
    chapterCount: 86,
    views: 1580000,
    updated: '2026-08-15',
    featured: true,
    newArrival: false,
    status: '连载中',
  },
  {
    id: 3,
    title: '恋之四季',
    author: '苏小满',
    category: '恋爱',
    categorySlug: 'lianAi',
    cover: 'https://readdy.ai/api/search-image?query=soft%20pastel%20anime%20manga%20cover%20art%20of%20two%20young%20people%20sharing%20a%20quiet%20moment%20under%20falling%20sakura%20petals%20in%20spring%2C%20warm%20pink%20and%20cream%20color%20palette%2C%20gentle%20romantic%20atmosphere%2C%20clean%20cute%20illustration%20style%20for%20a%20romance%20comic%20cover&width=600&height=800&seq=cover-love-seasons&orientation=portrait',
    short: '从春日的樱花到冬日的初雪，一场跨越四季的青涩暗恋终于开花结果。',
    intro: ['高一那年，转学生林晚在樱花树下遇见了沉默寡言的少年周予。从此，她的四季都有了不同的颜色。', '春日的约定、夏夜的烟火、秋天的落叶与冬日的初雪，这段藏在心底的暗恋，随着时间静静生长。故事以温柔的笔触，记录了少女心事与少年成长的全部细节。', '当毕业的钟声敲响，这份跨越四季的心意，能否终于说出口？一段治愈又心动的青春恋曲就此展开。'],
    tags: ['恋爱', '校园', '治愈', '青春'],
    rating: 9.6,
    chapterCount: 102,
    views: 3120000,
    updated: '2026-08-16',
    featured: true,
    newArrival: false,
    status: '连载中',
  },
  {
    id: 4,
    title: '幻境之森',
    author: '白鹿洲',
    category: '奇幻',
    categorySlug: 'qiHuan',
    cover: 'https://readdy.ai/api/search-image?query=enchanting%20anime%20manga%20cover%20art%20of%20a%20young%20sorceress%20standing%20at%20the%20entrance%20of%20a%20glowing%20mystical%20forest%20with%20fireflies%20and%20ancient%20trees%2C%20lush%20emerald%20green%20and%20golden%20light%2C%20magical%20fantasy%20atmosphere%2C%20detailed%20digital%20illustration%20for%20a%20fantasy%20comic%20cover&width=600&height=800&seq=cover-illusion-forest&orientation=portrait',
    short: '神秘古树的低语唤醒了沉睡的魔法，少女与精灵一同守护濒临崩塌的幻境。',
    intro: ['传说森林深处藏着一棵承载着世界魔力的古树，只要古树不倒，幻境便能永存。然而近年来，古树的力量却在不断减弱。', '平凡的森林少女艾薇偶然发现自己竟能与古树对话，也由此被卷入了守护幻境的宿命。在精灵使者与古代魔法师的帮助下，她踏上了一场横跨森林、深海与云端的奇幻冒险。', '当黑暗的力量逐渐逼近，少女将用爱与勇气，为这个即将崩塌的世界点亮最后的光。'],
    tags: ['奇幻', '魔法', '冒险', '治愈'],
    rating: 8.9,
    chapterCount: 75,
    views: 1260000,
    updated: '2026-08-14',
    featured: false,
    newArrival: true,
    status: '连载中',
  },
  {
    id: 5,
    title: '迷雾侦探社',
    author: '夜未央',
    category: '悬疑',
    categorySlug: 'xuanYi',
    cover: 'https://readdy.ai/api/search-image?query=moody%20anime%20manga%20cover%20art%20of%20a%20trench-coat%20detective%20holding%20a%20magnifying%20glass%20in%20a%20foggy%20rain-soaked%20city%20at%20night%2C%20dark%20teal%20and%20amber%20tones%2C%20noir%20mystery%20atmosphere%2C%20dramatic%20shadows%2C%20clean%20illustration%20for%20a%20mystery%20comic%20cover&width=600&height=800&seq=cover-fog-detective&orientation=portrait',
    short: '雨夜的城市藏着无数秘密，一间开在巷尾的侦探社，专接无法侦破的谜案。',
    intro: ['在常年被浓雾笼罩的滨城，有一家开在巷尾的"迷雾侦探社"。社长顾言是个观察力惊人的年轻人，他坚信每一个看似偶然的案件背后，都藏着必然的逻辑。', '他与毒舌但细心的助手、精通黑客的少女组成小队，接连破解了多起令警方束手无策的谜案。随着案件层层深入，一个牵涉整座城市的巨大阴谋逐渐浮出水面。', '当迷雾散去，真相远比想象中更令人震惊。这一次，侦探社能否找到真正的答案？'],
    tags: ['悬疑', '推理', '犯罪', '烧脑'],
    rating: 9.2,
    chapterCount: 64,
    views: 980000,
    updated: '2026-08-13',
    featured: false,
    newArrival: true,
    status: '连载中',
  },
  {
    id: 6,
    title: '云端日常',
    author: '阿茶',
    category: '日常',
    categorySlug: 'riChang',
    cover: 'https://readdy.ai/api/search-image?query=cozy%20slice-of-life%20anime%20manga%20cover%20art%20of%20a%20cheerful%20young%20woman%20in%20a%20bright%20apartment%20by%20a%20window%20overlooking%20fluffy%20clouds%2C%20warm%20sunny%20color%20palette%20of%20cream%20peach%20and%20soft%20yellow%2C%20relaxed%20heartwarming%20everyday%20atmosphere%2C%20clean%20kawaii%20illustration%20for%20a%20slice%20of%20life%20comic%20cover&width=600&height=800&seq=cover-cloud-daily&orientation=portrait',
    short: '在云端之上的一间小公寓里，少女用一日三餐与四季日常，治愈每一个疲惫的灵魂。',
    intro: ['住在城市边缘高层公寓的少女小云，经营着一个很小的美食账号。她相信，认真吃饭、好好生活，就是最简单的幸福。', '作品以单元剧的形式，记录小云与邻居、朋友和陌生人间一个个温暖又真实的小故事。深夜的一碗汤面、雨天的热茶、分享的便当，都是生活馈赠的温柔。', '没有惊天动地的剧情，只有熨帖人心的日常。这是一部适合在疲惫时打开，让心慢慢安静下来的治愈之作。'],
    tags: ['日常', '治愈', '美食', '温情'],
    rating: 9.3,
    chapterCount: 143,
    views: 2750000,
    updated: '2026-08-16',
    featured: false,
    newArrival: false,
    status: '连载中',
  },
  {
    id: 7,
    title: '爆笑日常屋',
    author: '皮皮虾',
    category: '搞笑',
    categorySlug: 'gaoXiao',
    cover: 'https://readdy.ai/api/search-image?query=funny%20cartoon%20manga%20cover%20art%20of%20a%20chaotic%20lively%20house%20with%20goofy%20exaggerated%20characters%20in%20comical%20poses%2C%20bright%20cheerful%20multicolor%20palette%20of%20orange%20yellow%20and%20teal%2C%20playful%20energy%2C%20humorous%20clean%20comic%20style%20illustration&width=600&height=800&seq=cover-comedy-house&orientation=portrait',
    short: '一家四口和一只猫的爆笑日常，笑点密集，看完心情瞬间变好。',
    intro: ['故事围绕一个平凡却无比闹腾的四口之家展开：爱做梦的老爸、精明能干的老妈、鬼点子多的大哥，以及总是状况百出的妹妹，还有一只自认是家里主人的猫。', '他们的日常永远充满意外——装修翻车、厨房爆炸、邻里大战、考试危机……每一个看似普通的场景，都能被他们演成喜剧。', '这是一部能让人捧腹大笑，又忍不住觉得"这就是我家"的欢乐之作。适合在心情低落时打开，一秒回血。'],
    tags: ['搞笑', '日常', '家庭', '轻松'],
    rating: 9.0,
    chapterCount: 118,
    views: 2040000,
    updated: '2026-08-15',
    featured: false,
    newArrival: false,
    status: '连载中',
  },
  {
    id: 8,
    title: '球场流星',
    author: '程亦凡',
    category: '运动',
    categorySlug: 'yunDong',
    cover: 'https://readdy.ai/api/search-image?query=energetic%20anime%20manga%20cover%20art%20of%20a%20basketball%20player%20mid-dunk%20on%20a%20glowing%20court%2C%20dynamic%20motion%20blur%2C%20bold%20orange%20and%20deep%20navy%20palette%2C%20sweat%20and%20intensity%2C%20sports%20drama%20atmosphere%2C%20clean%20dynamic%20illustration%20for%20a%20sports%20comic%20cover&width=600&height=800&seq=cover-court-meteor&orientation=portrait',
    short: '从校队替补到球场核心，少年用汗水与热爱，投出属于自己的那颗流星。',
    intro: ['身材并不高大的高中生程野，一直被人认为"不适合打篮球"。但他对篮球的热爱，从未因外界的质疑而熄灭。', '凭借惊人的毅力与对赛场的理解，程野从校队替补一步步成长为球队的核心。他与队友们并肩作战，在一次次失利中重新站起，共同向全国大赛发起冲击。', '汗水、泪水与欢呼，共同谱写了一曲关于青春与热爱的激昂乐章。运动番该有的燃与感动，这里全都有。'],
    tags: ['运动', '篮球', '青春', '热血'],
    rating: 9.1,
    chapterCount: 92,
    views: 1720000,
    updated: '2026-08-14',
    featured: false,
    newArrival: true,
    status: '连载中',
  },
  {
    id: 9,
    title: '剑与蔷薇',
    author: '洛云川',
    category: '热血',
    categorySlug: 'reXue',
    cover: 'https://readdy.ai/api/search-image?query=epic%20anime%20manga%20cover%20art%20of%20a%20knight%20wielding%20a%20glowing%20sword%20with%20roses%20blooming%20at%20his%20feet%2C%20dramatic%20red%20and%20gold%20palette%2C%20noble%20heroic%20atmosphere%2C%20detailed%20fantasy%20illustration%20for%20a%20fantasy%20adventure%20comic%20cover&width=600&height=800&seq=cover-sword-rose&orientation=portrait',
    short: '没落的骑士家族少年，为重振荣耀，用一柄断剑闯出一片崭新天地。',
    intro: ['古老的骑士家族一夜之间没落，唯有少年亚瑟手持先祖留下的断剑，守护着最后一丝荣耀。', '为查明家族覆灭的真相，他离开故土，踏上了充满险阻的征程。途中，他结识了各怀秘密的伙伴，也直面了横亘在眼前的强大敌人。', '当蔷薇绽放、剑刃再度闪耀，属于新一代骑士王的传奇，就此拉开帷幕。'],
    tags: ['热血', '奇幻', '骑士', '冒险'],
    rating: 8.8,
    chapterCount: 58,
    views: 860000,
    updated: '2026-08-12',
    featured: false,
    newArrival: true,
    status: '连载中',
  },
  {
    id: 10,
    title: '机械之心',
    author: '冷清秋',
    category: '科幻',
    categorySlug: 'keHuan',
    cover: 'https://readdy.ai/api/search-image?query=futuristic%20anime%20manga%20cover%20art%20of%20a%20half-human%20half-android%20young%20man%20with%20glowing%20cybernetic%20core%20in%20a%20neon%20cyberpunk%20city%2C%20cool%20cyan%20and%20magenta%20palette%2C%20high%20tech%20atmosphere%2C%20clean%20detailed%20illustration%20for%20a%20sci-fi%20comic%20cover&width=600&height=800&seq=cover-mech-heart&orientation=portrait',
    short: '在人类与机器人共生的未来都市，一名拥有"心"的改造人少年，开始寻找真实的自我。',
    intro: ['2120年，人类社会早已离不开机械。少年零号是一名拥有自主意识的改造人，他的核心深处，藏着一颗不属于任何程序的"心"。', '当这座城市开始接连发生针对改造人的神秘事件，零号被迫踏上了寻找真相的旅程。在这个过程中，他开始思考：拥有人类情感的机器，究竟算不算"人"？', '关于存在、记忆与爱的追问，构成了这部作品温柔而深邃的内核。'],
    tags: ['科幻', '赛博朋克', '机器人', '哲思'],
    rating: 9.0,
    chapterCount: 70,
    views: 1340000,
    updated: '2026-08-15',
    featured: false,
    newArrival: true,
    status: '连载中',
  },
  {
    id: 11,
    title: '樱花下落时',
    author: '许知夏',
    category: '恋爱',
    categorySlug: 'lianAi',
    cover: 'https://readdy.ai/api/search-image?query=gentle%20anime%20manga%20cover%20art%20of%20a%20girl%20watching%20cherry%20blossoms%20drift%20down%20under%20a%20soft%20evening%20sky%2C%20muted%20pastel%20pink%20and%20lavender%20palette%2C%20melancholic%20yet%20warm%20mood%2C%20delicate%20clean%20illustration%20for%20a%20romance%20comic%20cover&width=600&height=800&seq=cover-sakura-fall&orientation=portrait',
    short: '当樱花再次飘落，那个说好要一起看花的人，是否还会如期而至？',
    intro: ['每年春天，樱花大道都会迎来最绚烂的花期。少女鹿溪每年都会在这里，等待一个模糊的身影。', '那是她记忆中关于"约定"的全部——一个从未兑现，却从未忘记的约定。随着时间流逝，她渐渐明白，有些等待本身就是意义。', '这是一部关于错过、重逢与成长的青春故事。温柔、克制，又带着淡淡的遗憾与希望。'],
    tags: ['恋爱', '青春', '治愈', '伤感'],
    rating: 9.2,
    chapterCount: 66,
    views: 1190000,
    updated: '2026-08-13',
    featured: false,
    newArrival: false,
    status: '已完结',
  },
  {
    id: 12,
    title: '深夜食堂物语',
    author: '一灯',
    category: '日常',
    categorySlug: 'riChang',
    cover: 'https://readdy.ai/api/search-image?query=warm%20anime%20manga%20cover%20art%20of%20a%20cozy%20small%20diner%20counter%20at%20night%20with%20steaming%20bowls%20of%20food%20and%20a%20kind%20chef%2C%20warm%20amber%20and%20brown%20lighting%2C%20comforting%20evening%20atmosphere%2C%20clean%20cozy%20illustration%20for%20a%20food%20slice%20of%20life%20comic%20cover&width=600&height=800&seq=cover-midnight-diner&orientation=portrait',
    short: '凌晨零点开门的小食堂，用一碗热汤，收留每一个深夜里的失意灵魂。',
    intro: ['城市的一角，有家只在深夜零点开门的小食堂。老板话不多，却总能用最朴实的食物，抚慰每一位深夜访客。', '加班的上班族、失恋的年轻人、赶稿的作家、迷路的旅人……他们带着各自的故事而来，在热气腾腾的饭菜间，交换着彼此的悲欢。', '每一集都是一道菜、一个故事、一段人生。温暖、治愈，又直抵人心。'],
    tags: ['日常', '美食', '温情', '治愈'],
    rating: 9.5,
    chapterCount: 156,
    views: 2980000,
    updated: '2026-08-16',
    featured: false,
    newArrival: false,
    status: '连载中',
  },
];